import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  CATALOG,
  ROUTER_CATALOG_IAM,
  ROUTER_CATALOG_SEARCH,
  ROUTER_ESTIMATE,
  ROUTER_ESTIMATE_HISTORY,
  ROUTER_TIRES,
  ROUTER_UNIVERSAL_PRODUCTS,
} from 'app/AppRouter';
import { RootState } from 'app/AppStore';
import { FileAltIcon } from 'assets/icons';
import { SContainer } from 'components/Page/Header/SubHeader/SubHeader.styled';
import { getLastVehicleDetail } from 'domains/catalog/Catalog.store';
import { getCurrentEstimateId } from 'domains/estimate/Estimate.store';
import { getAvailableDMSService } from 'domains/user';
import CatalogBreadcrumb from 'pages/CatalogPage/common/CatalogBreadcrumb';
import EstimateModifyTabButtonsSection from 'pages/EstimatePage/EstimateModifyTabButtonsSection';
import { theme } from 'styles';
import { BackButton, Box, CenterFlex, Flex, IconButton } from 'UI';
import { CurrentVehicleButton } from 'UI/Button/CurrentVehicleButton';
import { HomeButton } from 'UI/Button/HomeButton';
import { useResetScroll } from 'utils/hooks/useResetScroll';

export const SUBHEADER_HEIGHT = 48;

const SubHeader = () => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const currentVehicle = useSelector(getLastVehicleDetail);
  const isCatalog = location.pathname.includes(CATALOG);
  const isEstimate =
    location.pathname.startsWith(ROUTER_ESTIMATE) && !location.pathname.startsWith(ROUTER_ESTIMATE_HISTORY);
  const isEstimateHistory = location.pathname.startsWith(ROUTER_ESTIMATE_HISTORY);
  const currentEstimateId = useSelector(getCurrentEstimateId);
  const isDMSAvailable = useSelector((state: RootState) => getAvailableDMSService(state, 'ESTIMATE'));
  useResetScroll([location.key]);

  const getHeaderBackButton = () => {
    const isIamSearch =
      location.pathname.startsWith(ROUTER_CATALOG_IAM) && location.pathname.includes(ROUTER_CATALOG_SEARCH);
    if (
      location.pathname.startsWith(ROUTER_TIRES) ||
      location.pathname.startsWith(ROUTER_UNIVERSAL_PRODUCTS) ||
      isIamSearch
    ) {
      return currentVehicle ? <CurrentVehicleButton currentVehicle={currentVehicle} /> : <HomeButton />;
    }
    return (
      <>
        <Flex size={0}>
          <BackButton />
        </Flex>
        {isCatalog && <CatalogBreadcrumb />}
      </>
    );
  };

  return (
    <SContainer
      background={theme.color.white}
      minHeight={SUBHEADER_HEIGHT}
      maxHeight={SUBHEADER_HEIGHT}
      data-cy={'top-menu-subheader'}
    >
      <Box width={'100%'}>
        <CenterFlex direction={'row'}>
          <Flex align={'center'} size={1} gap={20} padding={'0 0 0 30px'}>
            {getHeaderBackButton()}
          </Flex>
          {isEstimate && currentEstimateId && (
            <EstimateModifyTabButtonsSection
              estimateId={currentEstimateId}
              isDMSAvailable={isDMSAvailable}
              renderAddVehicle
            />
          )}
          {isEstimateHistory && (
            <Flex align={'center'} justify={'flex-end'} padding={'0px 30px'}>
              <IconButton
                IconComponent={FileAltIcon}
                round
                size={20}
                boxSize={'sm'}
                color={'grey15'}
                bgColor={'grey95'}
                hoverFill={'grey75'}
                tooltip={t('estimate.action.show_estimate', 'Show estimate')}
                onClick={() => history.push(ROUTER_ESTIMATE)}
                data-cy={'show-estimate-button'}
              />
            </Flex>
          )}
        </CenterFlex>
      </Box>
    </SContainer>
  );
};

export default SubHeader;
